export default "__VITE_ASSET__CHEP9ELO__"